// 接口 - 对账
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;
// 对账列表查询 - 列表
export function getCompanyPolicyBillList(params){
    return post(`${baseApi}/companyPolicyBill/list`, params);
}
// 保司对账筛选参数 - 选项列表
export function getCompanyPolicyBillArgOptions(params){
    return get(`${baseApi}/companyPolicyBill/arg`, params);
}
// 保单明细、保司返回差异单 - 数据导出
export const companyPolicyBillListExport = (params={}) => {
    return post(baseApi + "/companyPolicyBill/list", params, {
        responseType: "blob",
    });
}
// 批次 - 列表
export function getBatchList(params){
  return post(`${baseApi}/cashierDeskBill/list`, params);
}
// 批次 - 选项列表
export function getBatchPageOptions(params){
  return get(`${baseApi}/cashierDeskBill/query/argument`, params);
}

// 批次 - 新增、修改
export function batchAddOrUpdate(params){
  return post(`${baseApi}/cashierDeskBill/create`, params);
}
// 批次 - 数据导出
export const batchExport = (action, params={}) => {
  if (action === 'allOverview'){
    return post(baseApi + "/cashierDeskBill/download/bill/policy", params, {
      responseType: "blob",
    });
  }
  return post(baseApi + "/cashierDeskBill/download/error", params, {
    responseType: "blob",
  });
}
// 批次 - 数据上传
export const batchUpload = (action, params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  const apiLink = `${baseApi}/cashierDeskBill/upload/1`;

  return post(apiLink, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
